import { render } from "./BillingV3Frame.vue?vue&type=template&id=1c2ada68&scoped=true"
import script from "./BillingV3Frame.vue?vue&type=script&lang=ts"
export * from "./BillingV3Frame.vue?vue&type=script&lang=ts"

import "./BillingV3Frame.vue?vue&type=style&index=0&id=1c2ada68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c2ada68"

export default script